<template>
  <div class="switch_btn_warper" @click="switchBtnClickHandle">
    <div v-show="dswitchState" class="switch_btn_active">
      <img
        class="switch_btn_img"
        src="~assets/img/controlpublic/switchActive.png"
        alt
      />
    </div>
    <div v-show="!dswitchState" class="switch_btn_no_active">
      <img
        v-show="!dswitchState"
        class="switch_btn_img"
        src="~assets/img/controlpublic/switchNoActive.png"
        alt
      />
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      dswitchState: this.switchState
    }
  },
  props: {
    switchState: {
      type: Number,
      default: 0
    }
  },
  methods: {
    switchBtnClickHandle() {
      if (this.dswitchState === 0) {
        this.dswitchState = 1
      } else {
        this.dswitchState = 0
      }
      this.$emit('switchStateChange', this.dswitchState)
    }
  },
  watch: {
    switchState(val) {
      this.dswitchState = val
      this.$emit('switchStateChange', this.dswitchState)
    }
  }
}

/*
使用方法示例
       <control-switch-btn  :switchState="ControlSwitchBtnState" @switchStateChange="ControlSwitchBtnValue"></control-switch-btn> 
    父组件可以绑定变量数据ControlSwitchBtnState实时传递给子组件的props->switchState 
    父组件中创建ControlSwitchBtnValue方法接收状态的变化 如下
        ControlSwitchBtnValue(data) {
      console.log("子组件传回的值" + data);
      this.ControlSwitchBtnState=data;  ///接受数据，同时数据发生改变传给子组件的props->switchState
    },
    */
</script>

<style>
.switch_btn_warper {
  display: inline-block;
  width: 50px;
  height: 30px;
}
.switch_btn_no_active {
  width: 50px;
  height: 30px;
  text-align: center;
  border: 1px solid var(--control-outline-color);
  border-radius: 4px;
}
.switch_btn_active {
  width: 50px;
  height: 30px;
  text-align: center;
  border: 1px solid var(--control-outline-color);
  background-color: #f5f5f5;
  border-radius: 4px;
}
.switch_btn_img {
  width: 21px;
  height: 21px;
  margin-top: 5px;
}
</style>
